function getOrgIdByEnvironment() {
  const rawHostname =
    typeof window !== 'undefined' &&
    window.location &&
    typeof window.location.hostname === 'string'
      ? window.location.hostname
      : '';

  const hostname = String(rawHostname || '')
    .trim()
    .toLowerCase()
    .replace(/^www\./, '')
    .replace(/\.$/, '');

  if (!hostname) return '';

  // Stage / local
  if (
    hostname.endsWith('stage.s4pay.com.br') ||
    hostname.endsWith('stage.superbidpay.com.br') ||
    hostname === 'localhost' ||
    hostname === '127.0.0.1'
  ) {
    return '3et9q1i4';
  }

  // Produção (com ou sem www)
  if (hostname.endsWith('superbidpay.com.br')) return '1382cmqz';

  return '';
}


export default getOrgIdByEnvironment;